import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { AgenziaModel } from '../../crm/modules/settings/models/agenzia.model';
import { AuthModel } from '../models/auth.model';

export interface AuthState {
   auth: AuthModel | undefined;
   agenzia: AgenziaModel | undefined;
}
export function createInitialState(): AuthState {
  return {
    auth: undefined,
    agenzia: undefined
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'auth', resettable: true })
export class AuthStore extends Store<AuthState> {

  constructor() {
    super(createInitialState());
  }

}
